import clsx from 'clsx';
import React, { HTMLAttributes, PropsWithChildren } from 'react';

import styles from './SearchDropdownWrapper.module.scss';

export function SearchDropdownWrapper({ children, className }: PropsWithChildren & HTMLAttributes<HTMLElement>) {
  return (
    <div className={clsx(styles.resultsDropdown, 'text', className && styles[className])}>
      <div className={styles.wrapper}>{children}</div>
    </div>
  );
}
